import React from 'react'


export default function useUpdatingRef(value) {
    const ref = React.useRef(value)
    ref.current = value
    return ref
}
